export const LOADING = 'events/LOADING';
export const GET_ALL_EVENTS = 'events/GET_ALL_EVENTS';
export const SET_CURRENT_EVENT = 'events/SET_CURRENT_EVENT';

export const GET_EVENT_SUCCESS = 'events/GET_EVENT_SUCCESS';
export const REMOVE_EVENT_SUCCESS = 'events/REMOVE_EVENT_SUCCESS';
export const CREATE_EVENT_SUCCESS = 'events/CREATE_EVENT_SUCCESS';
export const UPDATE_EVENT_SUCCESS = 'events/UPDATE_EVENT_SUCCESS';